module.exports = __webpack_public_path__ + "img/dynamite.b53f990f.png";